import { TableLocal } from './TableLocal';
import { TableForeign } from './TableForeign';

export const PaymentMethod = () => {
  return (
    <div className='w-full px-6 flex flex-col gap-16 py-16 bg-p-wh rounded'>
      <TableForeign />
      <TableLocal />
    </div>
  );
};
